import React, { useState, useEffect } from "react";
import {Stack, Input, Box } from "@mui/material";

export default function CompanyRegisterTable(){
    
    const [originalData, setOriginalData]=useState([]);
    const [filteredData, setFilteredData]=useState([]);
    const [inputText, setInputText]=useState('');
    
    const loadData=(data)=>{
      setOriginalData(data);
      setFilteredData(data);
    }
    
    useEffect(()=>{
     let APIURL="/myapi/CompanyView";
     fetch(APIURL)
     .then( response => response.json())
     .then( json=> loadData(json))
     .finally(()=>{

     })
     .catch( errors => console.log("errors=" + errors ))
    },[])

    const handleChangeInput=(e)=>{
       setInputText(e.target.value);
    }

    useEffect(()=>{
      let newData=originalData.filter(
        originalData=> originalData.company_no.toLowerCase().includes(inputText.toLowerCase()) ||
        originalData.name.toLowerCase().includes(inputText.toLowerCase()) ||
        originalData.email.toLowerCase().includes(inputText.toLowerCase()) ||
        originalData.telephone1.toLowerCase().includes(inputText.toLowerCase()) ||
        originalData.telephone2.toLowerCase().includes(inputText.toLowerCase()) ||
        originalData.tin_no.toLowerCase().includes(inputText.toLowerCase()) 
      )

      setFilteredData(newData)

    }, [inputText])

    return(
       
        <Stack direction="row" spacing={1}>
           <Box flex={2}>

           </Box>
           
           <Box flex={2}>
            <Input 
            placeholder="Search"
             onChange={handleChangeInput}
             sx={{
                marginBottom:"20px"
             }}
            />

            <table>
                <tHead>
                    <tr>
                        <th>Company Number</th>
                        <th>Company Name</th>
                        <th>Company Email</th>
                        <th>Telephone 1</th>
                        <th>Telephone 2</th>
                        <th>TIN No</th>
                    </tr>

                </tHead>

                <tBody>
                 {
                    filteredData.map(function(td){
                     return(
                        <tr id={td.id}>
                         <td>{td.company_no}</td>
                         <td>{td.name}</td>
                         <td>{td.email}</td>
                         <td>{td.telephone1}</td>
                         <td>{td.telephone2}</td>
                         <td>{td.tin_no}</td>
                        </tr>
                     )
                    })
                 }
                </tBody>
            </table>
            </Box>
            
            <Box flex={2}>

            </Box>
        </Stack>
    )
}